import type { IconData } from '@stacksjs/iconify-core'

export const playlistAdd: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M256 152h208v32H256zm-80 104h288v32H176zm0 104h288v32H176zm16-208h-64V88H96v64H32v32h64v64h32v-64h64z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default playlistAdd
